var $ = require('jquery');
var ProviderAggregator = require('diy/search/ProviderAggregator');
var Elements = require('diy/search/providers/Elements');
var Help = require('diy/search/providers/Help');
var Features = require('diy/search/providers/Features');
var HelpLinks = require('diy/toolbar/help/helpLinks');

/**
 * Toolbar - Search class
 *
 * @depends jquery.js
 * @depends extendClass.js
 * @depends diy.searchBox.js
 * @depends diy.calloutLayer.js
 * @depends helpLinks.js
 * @depends providers/Help.js
 * @depends providers/Elements.js
 * @depends toolbar.js
 */
(function() {
    'use strict';
    var Search;

    var SEARCH_MIN_CHARS = 3;

    Search = Klazz.extend({
        options: {},
        toolbar: null,
        element: null,
        messages: {

        },
        /**
         * The element on which the searchbox is created
         */
        searchEl: null,
        /**
         * Element used as root for angular module (inside layer)
         */
        ngRootEl: null,

        /**
         * @type {ProviderAggregator}
         */
        providerAggregator: null,

        initialize: function(toolbar) {
            this.toolbar = toolbar;
            // Only available in the editor toolbar
            if (diy.context.type != 'editor') {
                return;
            }

            this.options = $.extend(true, {}, this.options); // note: we break object reference

            // get translations //
            // note: we break object reference
            this.messages = $.extend(true, {}, this.messages, jimdoData.messages.toolbarSearch);

            this.initProviders();

            if (!this.providerAggregator.hasProviders()) {
                // No providers available for search, we don't show the widget
                return;
            }

            this.providerAggregator
                .loadProviders()
                .done($.proxy(function(loadedProviders) {
                    if ($.isEmptyObject(loadedProviders)) {
                        window.console && console.log && console.log('Could not load any search provider. Search widget will be inactive!');
                    } else {
                        this.draw();
                    }
                }, this));
        },

        /**
         * Initialize the available search providers
         */
        initProviders: function() {
            this.providerAggregator = new ProviderAggregator();

            if (jimdoData.features.helpSearch) {
                this.providerAggregator.addProvider(
                    'help',
                    new Help()
                );
            }

            this.providerAggregator.addProvider(
                'elements',
                new Elements()
            );

            this.providerAggregator.addProvider(
                'features',
                new Features()
            );
        },

        //Public API (called by angular controller)
        hasHelpSearch: function() {
            return this.providerAggregator.hasLoadedProvider('help');
        },

        /**
         * Localized text for the search box placeholder. If we only have the
         * search provider for help, we show "Search help...". Otherwise we show
         * a generic "Search..." label
         *
         * @returns {String}
         */
        getPlaceholderText: function(showPlaceholder) {
            if (showPlaceholder === false) {
                return '';
            }
            var loadedProviders = this.providerAggregator.getLoadedProviderCount();

            if (loadedProviders == 1 && this.hasHelpSearch()) {
                return this.messages.helpPlaceholder;
            } else {
                return this.messages.placeholder;
            }
        },

        draw: function() {
            var elementHtml = '' +
                    '<div class="spacer"><div class="icon"></div></div>' +
                    '<div class="searchContainer">' +
                        '<div class="search"></div>' +
                    '</div>';
            this.element = this.toolbar.pushToPanel('right', elementHtml);

            this.searchEl = this.element.find('.search');

            this.searchEl
                .diy_searchBox({
                    searchButtonClickable: false,
                    clearButton: true,
                    texts: {
                        emptyText: this.getPlaceholderText(!diy.editor.uiPreference.isPointerModeTouch())
                    }
                })
                .bind("searchboxfocus", function(e) {
                    var centerPanel = this.toolbar.getPanel('center');
                    if (centerPanel && diy.editor.uiPreference.isPointerModeTouch()) {
                        //we hide the center panel which hosts the undo-redo stuff
                        centerPanel.hide();
                    }
                    $(document).trigger('diy-editor-search-focus');
                }.bind(this))
                .bind("searchboxblur", $.proxy(function(e) {
                    var centerPanel = this.toolbar.getPanel('center');
                    if (centerPanel && diy.editor.uiPreference.isPointerModeTouch() &&
                        !(this.searchEl.hasClass('callout-open')  || this.searchEl.hasClass('ui-state-focus'))
                    ) {
                        //we show the center panel which hosts the undo-redo stuff
                        centerPanel.show();
                        this.searchEl.find('a.ui-icon.ui-icon-close').hide();
                    }
                    this.searchEl.unbind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
                }, this))
                .bind("searchboxkeyup", $.proxy(function(e, ui) {
                    var keyCodes = $.ui.keyCode;

                    // If the keyboard navigation handler returns true
                    // it prevents any default behavior for that key and
                    // behavior of the search
                    if (this._handleKeyNav(e) === true) {
                        e.preventDefault();
                        return;
                    }

                    switch (e.keyCode) {
                        case keyCodes.ESCAPE:
                            this.searchEl.diy_searchBox('blur');
                            this.searchEl.diy_calloutLayer('hide');
                            break;

                        default:
                            this._onSearch(e, ui);
                            break;
                    }
                }, this))
                .bind("searchboxfocus", $.proxy(this._onSearch, this))
                .diy_calloutLayer({
                    cls: 'diye-toolbar-search',
                    anchorTarget: this.searchEl,
                    positionMode: 'fixed',
                    position: {
                        my: "left top",
                        at: "left bottom",
                        offset: (   diy.editor.uiPreference.isPointerModeTouch() ? '5' : '-10') + ' 5'
                    },
                    render: $.proxy(this._renderLayer, this),
                    show: $.proxy(function() {
                        this.searchEl.addClass('callout-open');
                    }, this),
                    hide: $.proxy(function() {
                        this.searchEl.removeClass('callout-open');
                        this.searchEl.trigger('searchboxblur');
                    }, this)
                });

            $('#diyToolbar').bind('diy-editor-toolbar-repositioned', $.proxy(this._positionLayer, this));
        },

        _getLayerTemplate: function() {
            // The template is defined inline in the angular module
            // do not declare ng-controller and ng-include on the same element. you have been warned
            return '<div ng-controller="SearchLayerCtrl"><div  ng-include="\'searchResults.html\'"></div></div>';
        },

        _renderLayer: function() {
            var contentEl = this.searchEl.diy_calloutLayer('getContentEl');

            if (!contentEl) {
                return;
            }

            this.ngRootEl = $(this._getLayerTemplate()).appendTo(contentEl);
            angular.bootstrap(this.ngRootEl, ['diy.search']);

            this._renderHelpLinks(contentEl.find('.no-results-wrapper'));

            contentEl.diy_scrollHandle();

            // Prevent the search box from loosing focus when clicking inside the
            // results layer
            contentEl.bind('click', $.proxy(function(e) {
                // Bugfix #DHDIY-20765: We don't focus the field again when
                // we clicked on a result, which closes the search
                if (!$(e.target).closest('.result').length) {
                    this.searchEl.diy_searchBox('focus');
                }
            }, this));
        },

        _showLayer: function() {
            if (this.searchEl.diy_calloutLayer("isVisible")) {
                return;
            }

            this.searchEl.diy_calloutLayer('show');

            this.refreshScroller(true);
        },

        // Public API (called by angular controller)
        refreshScroller: function(scrollToFirstItem) {
            var contentEl = this.searchEl.diy_calloutLayer('getContentEl');

            if (!contentEl || !this.searchEl.diy_calloutLayer('isVisible')) {
                return;
            }

            contentEl
                .trigger('contentchanged')
                .diy_alwaysInViewBehavior({
                    clickToOpen: true,
                    fixableSelector: '.diye-collapsible-category-header',
                    fixedClassName: 'fixed',
                    activeClassName: 'active'
                });

            if (scrollToFirstItem) {
                var firstResult = contentEl.find('.result:eq(0)');
                if (firstResult.length) {
                    contentEl.diy_alwaysInViewBehavior('scrollToItem', firstResult.get(0), undefined, 0);
                }
            }
        },

        // Public API (called by angular controller)
        scrollToResult: function(resultId) {
            var contentEl = this.searchEl.diy_calloutLayer('getContentEl'),
                firstResult;

            if (!contentEl || !this.searchEl.diy_calloutLayer('isVisible')) {
                return;
            }

            firstResult = contentEl.find('.result[data-result-id="' + resultId + '"]');
            if (firstResult.length > 0) {
                contentEl.diy_alwaysInViewBehavior('scrollItemIntoView', firstResult.get(0), undefined, 0);
            }
        },

        _positionLayer: function() {
            this.searchEl.diy_calloutLayer('refresh');
        },

        _onSearch: function(e, ui) {
            var searchEl = this.searchEl,
                searchPhrase = ui.value,
                searchResults;

            if (searchPhrase.length < SEARCH_MIN_CHARS) {
                searchEl.diy_calloutLayer('hide');
                return;
            }

            if (e.type == 'searchboxfocus' && searchEl.diy_calloutLayer('isVisible')) {
                // Nothing to do if we regained focus while the layer was still visible
                return;
            }

            searchResults = this.providerAggregator.search(searchPhrase);

            searchEl.diy_calloutLayer('render');

            this._updateResults(searchResults);

            if (e.type == 'searchboxfocus' && Modernizr.csstransitions) {
                this.searchEl.one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
                    $.proxy(this._showLayer, this)
                );
            } else {
                this._showLayer();
            }

            if (e.type != 'searchboxfocus') {
                $(document).trigger('diy-editor-search-search', {
                    searchPhrase: searchPhrase,
                    resultsFound: !$.isEmptyObject(searchResults)
                });
            }
        },

        _updateResults: function(searchResults) {
            var $scope = angular.element(this.ngRootEl).scope();

            $scope.$apply(function() {
                $scope.searchResults = searchResults;
            });
        },

        _handleKeyNav: function(e) {
            if (!this.ngRootEl) {
                return false;
            }

            var $scope = angular.element(this.ngRootEl).scope();

            return $scope.handleKeyNav(e);
        },

        _renderHelpLinks: function(contentEl) {
            if (!this.hasHelpSearch()) {
                return;
            }

            var $helpLinks = $('<div></div>')
                .addClass('help-links')
                .appendTo(contentEl);

            var helpLinksWidget = new HelpLinks($helpLinks);
            helpLinksWidget.render();

            $helpLinks.bind('helplinksclick', $.proxy(this._onHelpLinkClick, this));
        },

        _onHelpLinkClick: function(e, data) {
            this.searchEl.diy_calloutLayer('hide');

            $(document).trigger('diy-editor-search-helplinkclick', {
                helpLinkId: data.helpLinkId
            });
        },

        //public API (used by angular controller)
        openResult: function(e, index, result, catId) {
            this.providerAggregator.getProvider(result.providerName).action(result);
            this.searchEl.diy_searchBox('blur');

            this.searchEl.diy_calloutLayer('hide');

            $(document).trigger('diy-editor-search-resultclick', {
                resultIndex: parseInt(index, 10),
                categoryId: catId
            });
        }
    });

    module.exports = Search;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/search/search.js
 ** module id = 847
 ** module chunks = 0
 **/